import { createContext } from 'react';
import { HealthStatus } from '../types/health';

export type AuthState = 'checking' | 'authenticated' | 'redirecting';

export interface HealthStatusContextValue {
  healthStatus: HealthStatus | null;
  error: string | null;
  isInitializing: boolean;
  initializationMessage: string;
  authState: AuthState;
  refreshHealthStatus: () => Promise<void>;
}

export const HealthStatusContext = createContext<HealthStatusContextValue | undefined>(undefined);
